// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "init_pdfjs", inline: true, disabled: false };
const msgs = {
  start: ["init. pdfjs"],
  end: ["init. pdfjs", "init. success"],
  no_el: ["init. pdfjs", "no valid DOM el. provided"],
};

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_pdfjs() {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const { pdfCanvas, btn_prevPage, btn_nextPage } = this.ref;
  const { url_pdf } = this.options;
  this.logger("init", msgs.start, "action", logArgs);

  // Guard...
  if (!this.validate_refEl(pdfCanvas)) return this.cancel_featInit(msgs.no_el);

  //////////////////////////////////////////// ACTION ////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////// PDFjs setup //////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  const pdfPath = "/dummy-01.pdf";
  const pdfjsLib = window.pdfjsLib;
  pdfjsLib.GlobalWorkerOptions.workerSrc = "app/lib/pdfjs/pdf.worker.js";
  let pageNum = 1;
  let pdfDoc = null;

  //////////////////// PDF file loading and rendering ////////////////////
  ////////////////////////////////////////////////////////////////////////

  pdfjsLib.getDocument(url_pdf).promise.then(function (pdf) {
    pdfDoc = pdf;
    const scale = 2;
    const context = pdfCanvas.getContext("2d");

    ////////////// First page render. //////////////
    ////////////////////////////////////////////////

    pdf.getPage(pageNum).then(function (page) {
      const viewport = page.getViewport({ scale: scale });
      pdfCanvas.height = viewport.height;
      pdfCanvas.width = viewport.width;
      const renderContext = { canvasContext: context, viewport: viewport };
      page.render(renderContext);
    });

    //////////////// Controls init. ////////////////
    ////////////////////////////////////////////////

    btn_nextPage.addEventListener("click", function () {
      if (pageNum >= pdfDoc.numPages) return;
      pageNum++;
      pdfDoc.getPage(pageNum).then(function (page) {
        const viewport = page.getViewport({ scale: scale });
        pdfCanvas.height = viewport.height;
        pdfCanvas.width = viewport.width;
        const renderContext = { canvasContext: context, viewport: viewport };
        page.render(renderContext);
      });
    });

    btn_prevPage.addEventListener("click", function () {
      if (pageNum <= 1) return;
      pageNum--;
      pdfDoc.getPage(pageNum).then(function (page) {
        const viewport = page.getViewport({ scale: scale });
        pdfCanvas.height = viewport.height;
        pdfCanvas.width = viewport.width;
        const renderContext = { canvasContext: context, viewport: viewport };
        page.render(renderContext);
      });
    });
  });

  /////////////////////////////////////////// Conclude ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  this.logger("init", msgs.end, "success", logArgs);
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
